import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Contact from '../views/Contact.vue'
import Winkia from '../views/Winkia.vue'
import Error404 from '../views/Error404.vue'

export default {
    children: [
        {path: '/', component: Home},        
        {path: '/about', component: About},   
        {path: '/contact', component: Contact},   
        {path: '/winkia', component: Winkia},   
        
        {path: '/:id', component: Home},        
        {path: '/about/:id', component: About},   
        {path: '/contact/:id', component: Contact},   
        {path: '/winkia/:id', component: Winkia},   
        
        {path: '/*', component: Error404},
    ]
}


// WEBPACK FOOTER //
// ./src/router/routes.js